<template>
	<div id="app-v1-travel">
		<div :class="!onform ? 'bg-circle-wrap' : 'wrapper'">
            <header>
                <!-- added an if condition to not print the logo if a positive response is received from capone -->
                <div v-if="result != 0" id="logocont">
                    <svg width="62" height="45" viewBox="0 0 62 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Post Office</title>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M30.5013 44.305C14.0783 44.305 0.71875 34.5239 0.71875 22.5006C0.71875 10.4774 14.0783 0.695068 30.5013 0.695068C46.9221 0.695068 60.2806 10.4774 60.2806 22.5006C60.2806 34.5239 46.9221 44.305 30.5013 44.305Z" fill="#D71440"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M30.5001 0C22.429 0 14.8245 2.29446 9.08757 6.46028C6.25843 8.51437 4.03131 10.9166 2.46879 13.5991C0.829997 16.4129 0 19.4075 0 22.4995C0 25.5916 0.829997 28.5861 2.46879 31.4C4.03131 34.0823 6.25843 36.4835 9.08757 38.5388C14.8245 42.7046 22.429 45 30.5001 45C38.5722 45 46.1758 42.7046 51.9116 38.5388C54.7408 36.4835 56.9668 34.0823 58.5282 31.3989C60.1661 28.5861 60.997 25.5916 60.997 22.4995C60.997 19.4075 60.1661 16.4129 58.5282 13.5991C56.9668 10.9166 54.7408 8.51437 51.9116 6.46028C46.1758 2.29446 38.5722 0 30.5001 0ZM30.5001 1.39004C46.552 1.39004 59.5618 10.8396 59.5618 22.4995C59.5618 34.1583 46.552 43.61 30.5001 43.61C14.4503 43.61 1.43521 34.1583 1.43521 22.4995C1.43521 10.8396 14.4503 1.39004 30.5001 1.39004Z" fill="#FFFFFE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M36.2656 27.3388C36.2699 24.6308 38.4016 22.594 41.1311 22.5898C42.2177 22.5898 43.195 22.7973 43.9911 23.368V24.6554C43.3764 24.213 42.4986 23.8321 41.1311 23.8362C39.0451 23.8454 37.6967 25.258 37.7084 27.3388C37.7222 29.3684 39.1457 30.8395 41.1311 30.8395C42.3704 30.8395 43.0859 30.6198 43.9911 30.0203V31.3096C43.2035 31.8752 42.2177 32.0848 41.1311 32.0848C38.2405 32.0848 36.2624 29.9761 36.2656 27.3388Z" fill="#FFFFFE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M45.5703 22.8188V31.8579H51.8669V30.6115H46.9303V27.8603H51.2234V26.611H46.9303V24.063H51.6337V22.8188H45.5703Z" fill="#FFFFFE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M33.332 31.8578H34.6963V22.8188H33.332V31.8578Z" fill="#FFFFFE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.707 22.8188V31.8579H20.0722V27.9969H24.057V26.7506H20.0722V24.063H24.536V22.8188H18.707Z" fill="#FFFFFE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.63672 27.3388C7.63672 30.0469 9.72607 32.0857 12.4959 32.0857C15.2721 32.0857 17.3604 30.0469 17.3604 27.3388C17.3604 24.6338 15.2721 22.5898 12.4959 22.5898C9.72607 22.5898 7.63672 24.6338 7.63672 27.3388ZM9.07637 27.3388C9.07637 25.3073 10.5169 23.8342 12.4959 23.8342C14.4814 23.8342 15.9188 25.3073 15.9188 27.3388C15.9188 29.3663 14.4814 30.8395 12.4959 30.8395C10.5169 30.8395 9.07637 29.3663 9.07637 27.3388Z" fill="#FFFFFE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M25.9844 22.8188V31.8579H27.3497V27.9969H31.3343V26.7506H27.3497V24.063H31.8134V22.8188H25.9844Z" fill="#FFFFFE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M33.6602 13.3289C33.6602 15.3389 35.1261 15.7568 36.4182 16.1541C37.3744 16.4506 38.285 16.7566 38.285 17.6128C38.285 18.5101 37.279 18.9648 36.4182 18.9762C35.5236 18.9894 34.5335 18.5737 33.8191 18.083L33.8222 19.4032C34.5123 19.9576 35.478 20.2819 36.3896 20.2726C38.3062 20.2542 39.7054 19.0993 39.7054 17.4547C39.7054 15.6653 38.2606 15.2846 37.0352 14.9211C35.9995 14.6152 35.0583 14.3174 35.0583 13.3289C35.0583 12.8454 35.4706 12.0231 36.8422 12.0231C37.5494 12.0231 38.0687 12.1237 38.974 12.674L39.0673 12.7365L39.0705 11.4123C38.516 10.9965 37.7157 10.7769 36.8422 10.7769C34.5229 10.7789 33.6602 12.3454 33.6602 13.3289Z" fill="#FFFFFE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M40.2148 11.0054V12.2527H43.1819V20.0444H44.5461V12.2527H47.5143V11.0054H40.2148Z" fill="#FFFFFE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.9805 15.5257C22.9805 18.2338 25.0698 20.2726 27.8396 20.2726C30.6158 20.2726 32.7041 18.2338 32.7041 15.5257C32.7041 12.8208 30.6158 10.7769 27.8396 10.7769C25.0698 10.7769 22.9805 12.8208 22.9805 15.5257ZM24.42 15.5257C24.42 13.4943 25.8605 12.0211 27.8396 12.0211C29.825 12.0211 31.2624 13.4943 31.2624 15.5257C31.2624 17.5533 29.825 19.0264 27.8396 19.0264C25.8605 19.0264 24.42 17.5533 24.42 15.5257Z" fill="#FFFFFE"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9648 11.0054V20.0444H17.328V16.3805H19.2625C22.061 16.3805 22.2782 14.3201 22.2782 13.6899C22.2782 13.0626 22.061 11.0054 19.2625 11.0054H15.9648ZM19.0494 12.1746C19.765 12.1746 20.9702 12.3737 20.9702 13.6899C20.9702 15.01 19.765 15.206 19.0494 15.206H17.328V12.1746H19.0494Z" fill="#FFFFFE"/>
                    </svg>
                    <h1>{{full.logo.title}}</h1>
                </div>
			</header>
			<div :class="onform ? 'grid-wrapper' : 'grid-wrapper non-success'">
				<!--<div id="pagetop">
					<div v-if="onform" id="mainhead">
						<img id="mainimg" alt="" :src="require(`@/v1-travel/assets/images/${full.mainimg}`)"/>
						<h2>{{full.title}}</h2>
						<p>{{full.info}}</p>
						<summary-steps :obj="sections"></summary-steps>
						<p><strong id="brokerinfo">{{full.brokerinfo}}</strong></p>
					</div>
				</div>-->
				<res-header v-if="!onform" :res="result" :text="full.results" :balanceTransferRequestedDecision="btDecision"></res-header>
				<form id="creditCardForm" v-if="onform" @submit.prevent="formSubmit(sections)">
					<div class="warning grid-container">
						<div class="grid__inner">
							<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_26_8706)">
								<path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z" fill="#2E1A47"/>
								</g>
								<defs>
								<clipPath id="clip0_26_8706">
								<rect width="24" height="24" fill="white"/>
								</clipPath>
								</defs>
							</svg>
							<p id="warning">{{full.warning}}</p>
						</div>
					</div>
					<div class="formsect grid-container" v-bind:key="ind" v-for="(sect, ind) in sections">
						<div class="grid__inner">
							<p class="sectnumb-wrap">Step <span class="sectnumb">{{parseInt(ind) + 1}}</span> of 3</p>
							<sect-header :title="sect.title" :text="sect.note"></sect-header>
							<div class="form-error-summary top hidden js-form-error" aria-live="assertive" id="mainErrorSummary" v-if="ind == 0">
								<p class="form-error-summary__heading"><span id="errorsNumber">0 errors</span> in this form</p>
								<p class="form-error-summary__desc">Please complete or correct the following fields:</p>
								<ul id="mainErrorSummaryList">
								</ul>
							</div>
							<field v-bind:key="field.id" v-for="field in sect.formparts" :field="field"></field>
							<address-search v-if="ind == 1" :obj="address" :objManual="addressManual" :text="'current'"
								v-on:showprev="prevshow = true" v-on:hideprev="prevshow = false" @update-address="updateAddress" @reset-address-manual="resetAddressManual" v-on:update:editingCurrent="editingCurrent = $event">
							</address-search>
							<address-search v-if="(ind == 1) && (prevshow)" :hidden="editingCurrent" :obj="address" :objManual="addressManual" :text="'previous'" @update-address="updateAddress" @reset-address-manual="resetAddressManual" v-on:update:editingPrevious="editingPrevious = $event">
							</address-search>
						</div>
					</div>
					<div class="formsect grid-container" id="permissions">
						<div class="grid__inner">
							<consent-checks :title="full.permit.title" :text="full.permit.text"
							:link="full.permit.link" :obj="full.permit.options"></consent-checks>
						</div>
					</div>
					<div class="formsect grid-container tcs" id="tcs">
						<div class="grid__inner">
							<sect-header :title="full.tcs.title" :text="full.tcs.text"></sect-header>
							<p class="note">
								<span v-bind:key="text[1]" v-for="text in full.tcs.lastpara">
								<template v-if="text[0] == 'nolink'">{{text[1]}}</template>
								<a v-else :href="text[0]" target="_blank">{{text[1]}}</a>
								</span>
							</p>
							<div class="button-wrap">
								<submit-button :status="submitting" :obj="full.button"></submit-button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<!-- commented the below div class as part of summary page removal change -->
		<!-- <div id="rescont" v-else>
			<res-main :res="result" v-bind:key="card.title" v-for="card in cards" :obj="card" :url="agreementUrl"
			:id="polid" :token="retoken" :text="full.results.aprtext" :bin="showexample"></res-main>
		</div> -->
	
		<!-- added the below div to implement spinner logic before navigating to capone -->
		<div v-if="result == 0" class="spinner-container">
			<div class="spinner-background"></div>
			<div class="spinner">
				<div class="spinner-circle"></div>
			</div>
		</div>
	
		<!-- added a div class with an if condition to not print the footer details if a positive response is received from capone -->
		<div v-if="result != 0">
			<div id="capone" class="capone">
				<p>{{full.capone}}</p>
				<svg xmlns="http://www.w3.org/2000/svg" width="140" height="47" viewBox="0 0 140 47" fill="none">
                    <title>Capital One</title>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M39.1941 9.08839C64.5109 3.95015 124.056 -4.6784 133.302 4.87596C137.428 9.12542 128.714 16.8189 115.755 24.8827C115.257 22.8745 113.951 21.1258 112.111 20.0037C115.43 15.9579 116.119 12.5417 113.254 9.88459C103.87 1.18198 60.2471 6.02396 39.263 9.51426L38.6821 9.6161C38.6242 9.62981 38.5629 9.61936 38.5138 9.58743C38.4648 9.5555 38.4328 9.5052 38.426 9.44946C38.4146 9.39533 38.427 9.33915 38.4604 9.29378C38.4938 9.2484 38.5454 9.21772 38.6033 9.20875L39.1941 9.08839ZM74.4564 46.3059C81.9598 42.0194 88.8528 37.9366 94.761 34.0482C94.9893 34.7631 95.3207 35.4453 95.7457 36.0757L95.6275 36.1313C88.2915 39.9086 81.0047 43.5841 74.6632 46.6855L74.417 46.8059C74.3674 46.8378 74.3063 46.85 74.2472 46.8395C74.1881 46.8291 74.1358 46.797 74.1019 46.7503C74.0684 46.7052 74.0557 46.6491 74.0669 46.5951C74.078 46.541 74.1119 46.4935 74.161 46.4633L74.4564 46.3059Z" fill="#EB3C32"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M106.32 19.6626C99.4891 19.6626 94.781 25.3713 94.9932 30.9538C95.1572 35.3007 98.1384 38.1235 102.712 38.1686C109.861 38.1686 114.26 32.7665 114.038 26.8774C113.884 22.4944 110.893 19.6626 106.32 19.6626ZM103.213 37.0864C100.309 37.0864 98.0805 34.3989 97.9648 31.1342C97.8007 26.8053 100.917 20.4111 105.76 20.4111C108.664 20.4111 110.941 23.0806 111.067 26.3634C111.231 30.6562 108.838 37.0864 103.213 37.0864Z" fill="#1C2640"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M35.686 28.5771C35.8247 27.9962 35.9171 27.4067 35.9625 26.8133C36.002 25.3785 34.649 24.2361 30.4222 24.291C27.7767 24.3136 25.1364 24.5121 22.5216 24.885L21.4156 27.6266C23.4598 27.1606 27.4397 26.5208 29.563 26.9047C30.3432 27.0509 30.5407 27.3616 30.4321 27.9099C30.3728 28.2115 30.2148 28.376 29.8 28.5222C29.1673 28.7475 28.5014 28.8831 27.8249 28.9243C25.8893 29.0706 24.4375 29.2259 23.3907 29.3813C22.5766 29.4811 21.7819 29.6872 21.0304 29.9936C20.4349 30.2202 19.8993 30.5631 19.4602 30.9989C19.0595 31.4493 18.8121 31.9994 18.7491 32.5799C18.7239 33.3487 19.1411 34.0722 19.8453 34.4808C20.6255 35.0931 21.6921 35.2758 23.5882 35.2758C24.5411 35.2896 25.4915 35.182 26.4127 34.956C27.4058 34.7 28.3587 34.3252 29.247 33.841V35.2027H35.1724L35.2811 34.9925C34.8362 34.7956 34.5953 34.3421 34.6984 33.8959L35.686 28.5771ZM28.8915 30.5419C29.2258 30.4782 29.5555 30.3958 29.879 30.2952C29.8069 30.7093 29.7046 31.1184 29.5729 31.5198C29.4666 31.7822 29.2939 32.0172 29.0692 32.2052C28.7156 32.4699 28.3097 32.6685 27.8743 32.7901C27.4049 32.9287 26.9153 32.9996 26.4226 33.0003C25.9331 33.0367 25.4427 32.9415 25.0103 32.7261C24.7563 32.5758 24.6303 32.2951 24.6943 32.0224C24.7467 31.742 24.9218 31.494 25.1782 31.337C25.6448 31.0904 26.1637 30.9407 26.6991 30.8983C27.7656 30.7399 28.4964 30.6211 28.8915 30.5419Z" fill="#1C2640"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M57.9559 19.6626C56.3674 19.6626 54.9565 20.3933 54.7977 21.2833C54.6295 22.1827 55.7975 22.904 57.3766 22.904C58.9557 22.904 60.3947 22.1733 60.5442 21.2833C60.6937 20.3933 59.5444 19.6626 57.9559 19.6626ZM54.4986 23.8034L52.5645 34.6987H57.8998L59.834 23.8034H54.4986Z" fill="#1C2640"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M86.0715 28.5903C86.2123 28.0091 86.3149 27.4205 86.3788 26.8278C86.4086 25.4032 85.0799 24.28 80.8955 24.2891C78.2388 24.3102 75.5875 24.5117 72.963 24.8918L71.8525 27.6315C73.905 27.1657 77.8911 26.5265 80.0328 26.9192C80.8162 27.0653 81.0046 27.3849 80.8955 27.9146C80.836 28.225 80.6774 28.3894 80.2609 28.5355C79.6246 28.7561 78.9563 28.8884 78.2778 28.9282C76.3244 29.0743 74.8668 29.2387 73.8158 29.3848C73.0009 29.4868 72.2062 29.6959 71.4558 30.0058C70.8526 30.2232 70.3128 30.5671 69.8793 31.0103C69.4695 31.4562 69.22 32.0082 69.1653 32.5902C69.1379 33.3588 69.5574 34.0827 70.266 34.4897C71.0394 35.1015 72.1103 35.275 74.0141 35.275C74.9743 35.2933 75.9325 35.1857 76.8598 34.9554C77.8578 34.7016 78.8147 34.327 79.7056 33.8413V35.1928H85.655V35.0102C85.2149 34.808 84.9785 34.3576 85.0799 33.9143L86.0715 28.5903ZM79.2793 30.5629C79.6858 30.4715 80.0229 30.3893 80.2708 30.3072C80.2067 30.7224 80.1039 31.1318 79.9634 31.5309C79.8554 31.7951 79.6823 32.0327 79.4577 32.2249C79.1033 32.483 78.6998 32.6781 78.2679 32.8002C77.7964 32.938 77.3049 33.0088 76.8103 33.0103C76.3188 33.0477 75.826 32.9525 75.3923 32.7363C75.1336 32.5886 75.0028 32.3076 75.0651 32.0331C75.125 31.7556 75.2991 31.5102 75.551 31.3482C76.0205 31.1055 76.5414 30.9591 77.078 30.919C77.323 30.8814 77.5498 30.8471 77.7588 30.8156C78.4635 30.7091 78.9657 30.6333 79.2793 30.5629Z" fill="#1C2640"/>
                    <path d="M17.3659 30.6757C15.8273 30.9933 14.2538 31.148 12.6765 31.1367C9.97563 31.1367 7.85847 29.9344 7.94751 27.6833C8.02665 26.1916 9.92616 23.0545 14.8728 23.0545C16.4213 23.0285 17.9455 23.4081 19.2654 24.1484L19.9777 20.5322C18.2037 19.8935 16.303 19.601 14.3979 19.6734C7.93761 19.7367 1.73453 22.3855 0.972748 27.8098C0.210966 33.2341 7.59135 34.7077 10.866 34.6987C12.7655 34.6987 14.7343 34.6173 16.5744 34.4456L17.3659 30.6757Z" fill="#1C2640"/>
                    <path d="M63.1406 24.2661L63.5403 22.0339L69.3907 20.8188L68.7764 24.2661H71.6236L71.0873 26.4701H68.3084L66.6215 35.2767C66.6215 35.2767 61.0149 35.2767 60.9954 35.2767L62.6725 26.489H60.5566L60.9857 24.2755L63.1406 24.2661Z" fill="#1C2640"/>
                    <path d="M91.7943 34.6895L86.3789 34.6987L89.0959 19.6626L94.3717 19.8109L91.7943 34.6895Z" fill="#1C2640"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M37.4535 24.4552L34.7344 38.7469H40.2411L41.1508 33.8852C41.4235 34.1753 41.7322 34.434 42.0702 34.6557C42.4151 34.852 42.7917 34.9945 43.1852 35.0777C43.7588 35.1798 44.3433 35.2168 44.9263 35.1877C46.626 35.2882 48.3101 34.831 49.6897 33.8943C51.1705 32.9079 52.1649 31.4032 52.4479 29.7206C52.6636 28.7523 52.5787 27.7463 52.2034 26.8219C51.8271 25.9477 51.1152 25.2375 50.2081 24.8313C49.2651 24.4067 48.2183 24.2262 47.1759 24.3084C46.0867 24.3235 45.0107 24.5353 44.0069 24.9322C43.2094 25.2072 42.504 25.6757 41.9626 26.2898L42.3441 24.4552H37.4535ZM42.9505 27.5282C43.5133 27.1282 44.2005 26.9123 44.9067 26.9136C45.5463 26.864 46.1765 27.0823 46.6282 27.5099C47.0799 28.042 47.2259 28.7475 47.0194 29.3995C46.9283 29.9059 46.7215 30.3878 46.413 30.8122C46.1367 31.2001 45.7597 31.5157 45.3175 31.7295C44.8683 31.916 44.3806 32.0068 43.8895 31.9955C43.248 32.0328 42.6206 31.8088 42.168 31.3809C41.7353 30.7905 41.6163 30.0463 41.8452 29.3628C41.9395 28.638 42.3371 27.978 42.9505 27.5282Z" fill="#1C2640"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M138.014 35.3152L137.561 35.0276C136.579 36.5398 134.918 37.5345 133.062 37.722C132.234 37.7763 131.42 37.495 130.82 36.9474C130.22 36.3998 129.891 35.6366 129.913 34.8454C129.878 34.3745 129.926 33.9015 130.053 33.4455C133.767 33.3688 139.392 32.2373 139.251 28.4019C139.181 26.7143 137.641 26.0239 135.981 26.0239C132.116 26.0239 127.397 30.4443 127.578 35.2385C127.518 36.3232 127.938 37.3821 128.735 38.1582C129.533 38.9344 130.635 39.3569 131.774 39.3233C134.48 39.2125 136.891 37.6636 138.014 35.3152ZM135.568 26.6664C136.544 26.6664 137.048 27.2704 137.048 28.1718C137.148 30.6264 134.139 32.803 130.265 32.803C130.698 31.0387 133.203 26.6664 135.568 26.6664Z" fill="#1C2640"/>
                    <path d="M114.42 28.0423C114.804 27.9944 115.403 27.9274 115.708 27.9274C116.013 27.9274 116.504 28.004 116.524 28.4062C116.524 28.6361 116.092 30.3217 116.003 30.7239L115.128 34.459C114.774 35.9913 114.391 37.6003 114.047 38.8645H116.298L117.566 32.9362C121.419 29.0383 122.904 27.7645 123.818 27.7645C124.011 27.7465 124.202 27.8134 124.339 27.9468C124.476 28.0802 124.544 28.2663 124.526 28.4541C124.448 29.3695 124.26 30.2727 123.965 31.1453L122.668 35.4646C122.382 36.2636 122.22 37.0996 122.186 37.9451C122.163 38.3322 122.317 38.7094 122.608 38.9742C122.899 39.239 123.295 39.3638 123.69 39.3146C125.332 39.3146 126.531 37.6482 127.573 36.0201L127.268 35.4837C126.846 36.1446 125.873 37.5716 125.096 37.5716C124.86 37.5716 124.624 37.4183 124.624 37.0161C124.654 36.4159 124.769 35.8227 124.968 35.2539L126.403 30.1876C126.697 29.2886 126.885 28.3601 126.964 27.4198C126.989 27.0341 126.839 26.6573 126.552 26.3896C126.266 26.122 125.874 25.9908 125.479 26.0311C124.005 26.0311 122.039 27.075 117.881 31.7199H117.812L118.343 29.4597C118.628 28.2147 118.903 26.9218 119.178 26.0311C117.617 26.5669 116.021 27.002 114.401 27.3336L114.42 28.0423Z" fill="#1C2640"/>
                </svg>
			</div>
			<div class="smallprint" id="smallprint">
				<div>
					<p v-bind:key="text" v-for="text in full.smallprint">{{text}}</p>
				</div>
			</div>
			<footer>
                <svg width="62" height="45" viewBox="0 0 62 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <title>Post Office</title>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M30.5013 44.305C14.0783 44.305 0.71875 34.5239 0.71875 22.5006C0.71875 10.4774 14.0783 0.695068 30.5013 0.695068C46.9221 0.695068 60.2806 10.4774 60.2806 22.5006C60.2806 34.5239 46.9221 44.305 30.5013 44.305Z" fill="#D71440"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M30.5001 0C22.429 0 14.8245 2.29446 9.08757 6.46028C6.25843 8.51437 4.03131 10.9166 2.46879 13.5991C0.829997 16.4129 0 19.4075 0 22.4995C0 25.5916 0.829997 28.5861 2.46879 31.4C4.03131 34.0823 6.25843 36.4835 9.08757 38.5388C14.8245 42.7046 22.429 45 30.5001 45C38.5722 45 46.1758 42.7046 51.9116 38.5388C54.7408 36.4835 56.9668 34.0823 58.5282 31.3989C60.1661 28.5861 60.997 25.5916 60.997 22.4995C60.997 19.4075 60.1661 16.4129 58.5282 13.5991C56.9668 10.9166 54.7408 8.51437 51.9116 6.46028C46.1758 2.29446 38.5722 0 30.5001 0ZM30.5001 1.39004C46.552 1.39004 59.5618 10.8396 59.5618 22.4995C59.5618 34.1583 46.552 43.61 30.5001 43.61C14.4503 43.61 1.43521 34.1583 1.43521 22.4995C1.43521 10.8396 14.4503 1.39004 30.5001 1.39004Z" fill="#FFFFFE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M36.2656 27.3388C36.2699 24.6308 38.4016 22.594 41.1311 22.5898C42.2177 22.5898 43.195 22.7973 43.9911 23.368V24.6554C43.3764 24.213 42.4986 23.8321 41.1311 23.8362C39.0451 23.8454 37.6967 25.258 37.7084 27.3388C37.7222 29.3684 39.1457 30.8395 41.1311 30.8395C42.3704 30.8395 43.0859 30.6198 43.9911 30.0203V31.3096C43.2035 31.8752 42.2177 32.0848 41.1311 32.0848C38.2405 32.0848 36.2624 29.9761 36.2656 27.3388Z" fill="#FFFFFE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M45.5703 22.8188V31.8579H51.8669V30.6115H46.9303V27.8603H51.2234V26.611H46.9303V24.063H51.6337V22.8188H45.5703Z" fill="#FFFFFE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M33.332 31.8578H34.6963V22.8188H33.332V31.8578Z" fill="#FFFFFE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.707 22.8188V31.8579H20.0722V27.9969H24.057V26.7506H20.0722V24.063H24.536V22.8188H18.707Z" fill="#FFFFFE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.63672 27.3388C7.63672 30.0469 9.72607 32.0857 12.4959 32.0857C15.2721 32.0857 17.3604 30.0469 17.3604 27.3388C17.3604 24.6338 15.2721 22.5898 12.4959 22.5898C9.72607 22.5898 7.63672 24.6338 7.63672 27.3388ZM9.07637 27.3388C9.07637 25.3073 10.5169 23.8342 12.4959 23.8342C14.4814 23.8342 15.9188 25.3073 15.9188 27.3388C15.9188 29.3663 14.4814 30.8395 12.4959 30.8395C10.5169 30.8395 9.07637 29.3663 9.07637 27.3388Z" fill="#FFFFFE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M25.9844 22.8188V31.8579H27.3497V27.9969H31.3343V26.7506H27.3497V24.063H31.8134V22.8188H25.9844Z" fill="#FFFFFE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M33.6602 13.3289C33.6602 15.3389 35.1261 15.7568 36.4182 16.1541C37.3744 16.4506 38.285 16.7566 38.285 17.6128C38.285 18.5101 37.279 18.9648 36.4182 18.9762C35.5236 18.9894 34.5335 18.5737 33.8191 18.083L33.8222 19.4032C34.5123 19.9576 35.478 20.2819 36.3896 20.2726C38.3062 20.2542 39.7054 19.0993 39.7054 17.4547C39.7054 15.6653 38.2606 15.2846 37.0352 14.9211C35.9995 14.6152 35.0583 14.3174 35.0583 13.3289C35.0583 12.8454 35.4706 12.0231 36.8422 12.0231C37.5494 12.0231 38.0687 12.1237 38.974 12.674L39.0673 12.7365L39.0705 11.4123C38.516 10.9965 37.7157 10.7769 36.8422 10.7769C34.5229 10.7789 33.6602 12.3454 33.6602 13.3289Z" fill="#FFFFFE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M40.2148 11.0054V12.2527H43.1819V20.0444H44.5461V12.2527H47.5143V11.0054H40.2148Z" fill="#FFFFFE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22.9805 15.5257C22.9805 18.2338 25.0698 20.2726 27.8396 20.2726C30.6158 20.2726 32.7041 18.2338 32.7041 15.5257C32.7041 12.8208 30.6158 10.7769 27.8396 10.7769C25.0698 10.7769 22.9805 12.8208 22.9805 15.5257ZM24.42 15.5257C24.42 13.4943 25.8605 12.0211 27.8396 12.0211C29.825 12.0211 31.2624 13.4943 31.2624 15.5257C31.2624 17.5533 29.825 19.0264 27.8396 19.0264C25.8605 19.0264 24.42 17.5533 24.42 15.5257Z" fill="#FFFFFE"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9648 11.0054V20.0444H17.328V16.3805H19.2625C22.061 16.3805 22.2782 14.3201 22.2782 13.6899C22.2782 13.0626 22.061 11.0054 19.2625 11.0054H15.9648ZM19.0494 12.1746C19.765 12.1746 20.9702 12.3737 20.9702 13.6899C20.9702 15.01 19.765 15.206 19.0494 15.206H17.328V12.1746H19.0494Z" fill="#FFFFFE"/>
                </svg>
                <p class="copyright">Copyright {{getCurrentYear()}} Post Office</p>
                <ul class="footer-links">
                    <li v-bind:key="link[1]" v-for="link in full.footer">
                        <a :href="link[0]"><span>{{link[1]}}</span></a>
                    </li>
                </ul>
			</footer>
		</div>
	</div>
	</template>
	
	<script>
	
	/*eslint-disable */
	
	import '@/v1-travel/assets/css/global.css'
	
	import iconGroup from './../components/iconGroup.vue'
	import resHeader from './../components/resHeader.vue'
	import resMain from './../components/resMain.vue'
	import sectHeader from './../components/sectHeader.vue'
	import summarySteps from './../components/summarySteps.vue'
	import field from './../components/field.vue'
	import addressSearch from './../components/addressSearch.vue'
	import consentChecks from './../components/consentChecks.vue'
	import submitButton from './../components/submitButton.vue'
	
	export default {
		name: 'app',
		data: function() {
			return {
				full: content_travel,
				sections: content_travel.sections,
				address: [
					["House name or number", "houseName", true],
					["Postcode", "postCodeAuto", true]
				],
				addressManual: [
					["Flat number", "flatNumber", false, "", ""],
					["House name", "houseNameManual", false, "", ""],
					["House number", "houseNumber", false, "", ""],
					["Street name", "streetName", true, "", ""],
					["Address line 2", "localityName", false, "", ""],
					["Town/city", "townName", true, "", ""],
					["County", "countyName", true, "", ""],
					["Postcode", "postCode", true, "", ""]
				],
				submitting: false,
				onform: true,
				prevshow: false,
				result: 2,
				btDecision: "",
				retoken: "",
				agreementUrl: "",
				polid: "",
				cards: content_travel.creditwise,
				showexample: process.env.VUE_APP_SHOW_EXAMPLE,
				api: process.env.VUE_APP_API_URL,
				key: process.env.VUE_APP_CLIENT_SECRET,
				usesample: false,
				sample: {},
				editingCurrent: false,
				editingPrevious: false
			}
		},
		components: {
			iconGroup,
			resHeader,
			resMain,
			sectHeader,
			summarySteps,
			field,
			addressSearch,
			consentChecks,
			submitButton
		},
		methods: {
            updateAddress(updatedAddress) {
                this.addressManual.forEach(item => {
                    if (updatedAddress.hasOwnProperty(item[1])) {
                        if(!this.prevshow) {
                            item[3] = updatedAddress[item[1]];
                        } else {
                            item[4] = updatedAddress[item[1]];
                        }
                    }
                });
            },
            resetAddressManual(type) {
                if (type === 'current') {
                    // Reset the third index of each item in addressManual
                    this.addressManual.forEach(item => {
                        item[3] = "";
                    });
                } else if (type === 'previous') {
                    // Reset the fourth index of each item in addressManual
                    this.addressManual.forEach(item => {
                    	item[4] = "";
                    });
                }
			},
			formSubmit: function(a) {
				if (validationNew() || this.usesample) {
					this.submitting = true;
					var postdata = this.sample;
					if (!this.usesample) {
						postdata = createJSON(a);
					}
					var parentapp = this;
					var xhttp = new XMLHttpRequest();
					postRequest(this.api, this.key, postdata, xhttp);
					var cardcolours = ["Black", "Red"];
					for (var i = 0; i < cardcolours.length; i++) {
						var cardimage = new Image();
						cardimage.src = require(`@/v1-travel/assets/images/${cardcolours[i]}VisaCard.png`);
					}
					xhttp.onreadystatechange = function() {
						if (this.readyState == 4 && this.status == 200) {
							var response = JSON.parse(this.responseText).quotation;
							parentapp.polid = JSON.parse(this.responseText).polReferenceId;
							if (response) {
								if (response.productResults) {
									if (response.productResults.length > 0) {
										parentapp.full.results.name = getById("firstName").value;
										parentapp.retoken = response.retrievalToken;
										parentapp.cards = response.productResults;
										parentapp.agreementUrl = response.agreementUrl;
										parentapp.verifyUrl = response.verifyUrl;
										parentapp.result = 0;
										if (response.productResults[0].creditRequestedDecisions) {
											parentapp.btDecision = response.productResults[0].creditRequestedDecisions[0].creditDecision;
											if (response.productResults[0].creditRequestedDecisions[0].hasOwnProperty("creditDecision")) {
											parentapp.full.results.creditAmount = getById("creditAmount").value;
											}
										}
	
										//added the below logic to redirect to capone if a positive response is received from capone
										let apply_url = response.agreementUrl.replace(response.retrievalToken, encodeURIComponent(response.retrievalToken)).replace("PRODUCT_ID_REPLACE", response.productResults[0].productId).replace("V_REPLACE", sourcecode);
										let check_campaign = urlParam('campaign');
										if(check_campaign !== null){
											apply_url = apply_url + `&campaign=${check_campaign}`
										}
										let check_pcr = urlParam('pcr');
										if(check_pcr !== null){
											apply_url = apply_url + `&pcr=${check_pcr}`
										}
										location.href = apply_url;
																												
									} else {parentapp.result = 1;}
								} else {parentapp.result = 1;}
							} else {
								parentapp.result = 1;
							}
							parentapp.onform = false;
						} else if (this.readyState == 4) {
							parentapp.onform = false;
						}
						scrollToY(0, 0);
					}
				}
			},
            getCurrentYear() {
                return new Date().getFullYear();
            }
		}
	}
	</script>
	
	<style>

	.formgroup {
		margin: 0px;
		padding: 0;
		border: 0px;
		vertical-align: top;
		margin-top: 2rem;
	}

	.button-wrap {
		margin-top: 2rem;
		border-top: 0.0625rem solid #e6e6e6;
		padding-top: 2rem;
	}

	.additional-info {
		display: block;
		font-size: 1.125rem;
		line-height: 1.75rem;
		margin: 0;
		margin-bottom: 0.5rem;
		color: #444;
	}
	
	.radio:checked+label:after,
	.checknumb:checked+label:after {
		background: url('../assets/images/whitetick.png') -10px;
	}
	
	.checkbin:checked+label:before {
		background: url('../assets/images/whitetick.png') -8px;
	}
	
	.redtickl:before {
		background: url('../assets/images/redtick.png');
	}
	
	/* CSS for the spinner logic */
	.spinner-container {
	  position: fixed;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  z-index: 9999;
	}
	
	.spinner-background {
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
	}
	
	.spinner {
	  position: relative;
	}
	
	.spinner-circle {
	  width: 40px;
	  height: 40px;
	  border-radius: 50%;
	  border: 3px solid #ccc;
	  border-top-color: #333;
	  animation: spin 1s linear infinite;
	}
	
	@keyframes spin {
	  to {
		transform: rotate(360deg);
	  }
	}

	@media screen and (max-width: 47.938rem) {
		.button-wrap {
			margin-top: 2rem;
			border-top: none;
			padding-top: 0;
		}
	}
	
	</style>